(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ss-search-dialog"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('ss-search-panel')){
customElements.define('ss-search-panel',class extends HTMLElement{
connectedCallback(){
 if(this.ready)return;this.ready=true;this.dialog=this.querySelector('dialog');this.input=this.querySelector('.ss-search-input');this.results=this.querySelector('.ss-search-results');this.status=this.querySelector('.ss-search-status');this.initial=this.status.textContent;this.all=this.querySelector('.ss-search-all');this.base=this.all.href;this.tab='products';this.sequence=0;
 this.onOpen=e=>{const trigger=e.target.closest('.ss-search-trigger,.show-search-link');if(!trigger||!this.isConnected)return;e.preventDefault();e.stopImmediatePropagation();this.opener=trigger;this.dialog.showModal();document.documentElement.classList.add('ss-search-open');this.input.focus();};document.addEventListener('click',this.onOpen,true);
 this.dialog.addEventListener('keydown',e=>{if(e.key==='Escape'){e.preventDefault();e.stopPropagation();this.dialog.close();}});this.dialog.addEventListener('close',()=>{document.documentElement.classList.remove('ss-search-open');this.opener?.focus();});this.querySelector('.ss-search-close').addEventListener('click',()=>this.dialog.close());this.dialog.addEventListener('click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();}});
 this.input.addEventListener('input',()=>this.schedule());this.querySelector('form').addEventListener('reset',()=>{this.input.value='';this.schedule();this.input.focus();});this.querySelectorAll('[data-tab]').forEach((button,i)=>{button.addEventListener('click',()=>this.select(button.dataset.tab));button.addEventListener('keydown',e=>{if(['ArrowLeft','ArrowRight','Home','End'].includes(e.key)){e.preventDefault();const tabs=[...this.querySelectorAll('[data-tab]')];const next=e.key==='Home'?0:e.key==='End'?1:1-i;this.select(tabs[next].dataset.tab);tabs[next].focus();}});});
}
disconnectedCallback(){document.removeEventListener('click',this.onOpen,true);clearTimeout(this.timer);this.controller?.abort();document.documentElement.classList.remove('ss-search-open');}
select(tab){this.tab=tab;this.querySelectorAll('[data-tab]').forEach(b=>{const active=b.dataset.tab===tab;b.setAttribute('aria-selected',String(active));b.tabIndex=active?0:-1;});this.results.querySelectorAll('[data-panel]').forEach(p=>p.hidden=p.dataset.panel!==tab);}
schedule(){clearTimeout(this.timer);this.controller?.abort();const sequence=++this.sequence;const query=this.input.value.trim();this.results.innerHTML='';this.all.hidden=!query;if(!query){this.status.textContent=this.initial;return;}const all=new URL(this.base);all.searchParams.set('q',query);all.searchParams.set('type','product');all.searchParams.set('options[prefix]','last');this.all.href=all;this.status.textContent=this.dataset.loading;this.timer=setTimeout(()=>this.search(query,sequence),200);}
async search(query,sequence){this.controller=new AbortController();try{const url=new URL(this.dataset.url,location.origin);url.searchParams.set('q',query);url.searchParams.set('resources[type]','product,query');url.searchParams.set('resources[limit]','10');url.searchParams.set('resources[limit_scope]','each');url.searchParams.set('section_id','ss-predictive-search');const response=await fetch(url,{signal:this.controller.signal});if(!response.ok)throw new Error();const html=await response.text();if(sequence!==this.sequence)return;const parsed=new DOMParser().parseFromString(html,'text/html');const content=parsed.querySelector('[data-ss-predictive]');if(!content)throw new Error();this.results.innerHTML=content.innerHTML;this.status.textContent=content.dataset.announcement||'';this.select(this.tab);}catch(e){if(e.name!=='AbortError'&&sequence===this.sequence)this.status.textContent=this.dataset.error;}}
});}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ss-size-guide"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('ss-size-guide')){
  customElements.define('ss-size-guide',class extends HTMLElement{
    connectedCallback(){
      if(this.initialized)return;
      this.initialized=true;
      const dialog=this.querySelector('dialog');
      const trigger=this.querySelector('.ss-size-guide__trigger');
      trigger.addEventListener('click',()=>dialog.showModal());
      this.querySelector('.ss-size-guide__close').addEventListener('click',()=>dialog.close());
      dialog.addEventListener('click',event=>{
        if(event.target!==dialog)return;
        const rect=dialog.getBoundingClientRect();
        if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();
      });
      dialog.addEventListener('close',()=>trigger.focus());
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ss-skibot"] && !Shopify.designMode) return;
  try {
    (() => {
  const art = document.getElementById('ss-skibot-art');
  if (!art) return;
  const roots = new WeakSet();
  let watchedHostRoot;
  const css = `
    .activator.ss-skibot {
      width: 64px !important; height: 76px !important; min-width: 64px !important;
      padding: 5px 6px 7px !important; gap: 0 !important;
      display: flex !important; flex-direction: column !important; justify-content: center !important;
      border-radius: 32px 32px 22px 22px !important;
      background: #303130 !important; color: #f5f0e6 !important;
      border: 1px solid rgba(245,240,230,.4) !important;
      box-shadow: 0 3px 12px rgba(30,31,30,.16) !important;
    }
    .ss-skibot .activator__icon { display: flex !important; width: 48px !important; height: 48px !important; }
    .ss-skibot-face { display: block; width: 48px; height: 48px; }
    .ss-skibot .activator__label { display: block !important; color: #f5f0e6 !important; font-weight: 600; font-family: inherit; font-size: 11px !important; line-height: 15px !important; letter-spacing: .3px; }
    .ss-skibot .activator__indicator { position: absolute !important; top: 5px !important; right: 4px !important; background: #c2534b !important; border: 2px solid #f5f0e6 !important; }
    .activator.ss-skibot:focus-visible { outline: 3px solid #c2534b !important; outline-offset: 3px; }
    @media (max-width: 767px) {
      .activator.ss-skibot { width: 56px !important; min-width: 56px !important; height: 66px !important; padding: 3px 5px 5px !important; border-radius: 28px 28px 19px 19px !important; }
      .ss-skibot .activator__icon, .ss-skibot-face { width: 42px !important; height: 42px !important; }
    }
  `;
  function apply(root) {
    const button = root.querySelector('button.activator');
    if (!button) return;
    const icon = button.querySelector('.activator__icon');
    const label = button.querySelector('.activator__label');
    if (!icon || !label) return;
    if (!root.querySelector('#ss-skibot-style')) {
      const style = document.createElement('style');
      style.id = 'ss-skibot-style';
      style.textContent = css;
      root.append(style);
    }
    button.classList.add('ss-skibot');
    if (button.getAttribute('aria-label') !== art.dataset.accessible) button.setAttribute('aria-label', art.dataset.accessible);
    if (label.textContent !== art.dataset.label) label.textContent = art.dataset.label;
    if (!icon.querySelector('.ss-skibot-face')) icon.replaceChildren(art.content.cloneNode(true));
    const title = root.querySelector('#shopify-agent-panel-title');
    if (title && title.textContent !== art.dataset.label) title.textContent = art.dataset.label;
  }
  function connect() {
    const host = document.querySelector('shopify-chat');
    const hostRoot = host?.shadowRoot;
    if (hostRoot && watchedHostRoot !== hostRoot) {
      watchedHostRoot = hostRoot;
      new MutationObserver(start).observe(hostRoot, {childList:true});
      const wrapper = hostRoot.querySelector('#shopify-element-wrapper');
      if (wrapper) new MutationObserver(start).observe(wrapper, {childList:true});
    }
    const runtime = hostRoot?.querySelector('shopify-agent-runtime');
    const root = runtime ? runtime.shadowRoot : hostRoot;
    if (!root) return false;
    apply(root);
    if (!roots.has(root)) {
      roots.add(root);
      new MutationObserver(() => apply(root)).observe(root, {childList:true, subtree:true});
    }
    return !!root.querySelector('button.ss-skibot');
  }
  let timer;
  function start() {
    clearInterval(timer);
    let attempts = 0;
    if (connect()) return;
    timer = setInterval(() => {
      if (connect() || ++attempts >= 120) clearInterval(timer);
    }, 500);
  }
  start();
  document.addEventListener('shopify:section:load', start);
})();
  } catch(e) { console.error(e); }
})();

})();
